// extracted by mini-css-extract-plugin
module.exports = {"item":"AccordionTextItemRefresh_item__79Tdm","trigger":"AccordionTextItemRefresh_trigger__SmKl5","content":"AccordionTextItemRefresh_content__qxy4h"};